export default __webpack_public_path__ + "static/media/tick.1bf9bdaf.svg";